import {
  TCreditsAutoRechargeConfig,
  TCreditsWithdrawbleCredits,
  TMenhirCreditsAutoRechargeConfig,
  TMenhirCreditsWithdrawble,
  TMenhirPostCreditsWithdrawResponse,
  TPostCreditsWithdrawResponse,
} from '@/common/integrations/menhir/employee/credits/credits.types';

export const transformCreditsAutoRechargeConfig = (
  config: TMenhirCreditsAutoRechargeConfig
): TCreditsAutoRechargeConfig => {
  return {
    thresholdAmount: config.threshold_amount,
    targetAmount: config.target_amount,
    paymentMethodId: config.payment_method_id,
  };
};

export const transformCreditsWithdrawable = (
  response: TMenhirCreditsWithdrawble
): TCreditsWithdrawbleCredits => {
  return {
    withdrawableAmount: response.withdrawable_amount,
  };
};

export const transformCreditsWithdraw = (
  response: TMenhirPostCreditsWithdrawResponse
): TPostCreditsWithdrawResponse => {
  return {
    operationId: response.operation_id,
  };
};
